import { Route } from '@angular/router';
import { operatorRoutes } from './pages/operators/operators.route';

export const settingsRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'operators',
    pathMatch: 'full',
  },
  {
    path: 'operators',
    loadComponent: () => import('./pages').then(p => p.OperatorsPage),
    title: 'UIMS - Operators',
    children: operatorRoutes,
  },
];
